<template>
    <div class="page_searchbar">
        <div class="search_bar">
            <div class="container">
                <div class="search_bar_box">
                    <div class="search_box">
                        <a-input :placeholder="$t('common.search')" class="search" v-model="search" @focus="focus=true" @blur="focus=false" @pressEnter="goToMenu">
                            <a-icon slot="prefix" type="search" />
                            <span  slot="suffix">
                                <a-icon type="close-circle" theme="filled" style="color:rgba(0, 0, 0, 0.25); cursor:pointer" v-if="search && search != ''" @click="search=null"/>
                            </span>
                        </a-input>
                        <div class="search_divider"><div class="search_divider_line" :style="{background:focus?'#ccc':'#f5f5f5'}"></div></div>
                        <div class="search_history" v-show="focus">
                            <ul>
                                <li v-for="(item, index) in searchMenus" :key="index" @mousedown="search = item; goToMenu()">{{item}}</li>
                                <li v-if="searchMenus.length==0" class="no_related">{{$t("searchBar.empty")}}</li>
                            </ul>
                        </div>
                    </div>
                    <a-button type="primary" @click="goToMenu">{{$t("common.search")}}</a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import storage from '@/utils/storage'
export default {
    components: {
    },
    mounted(){
        let histories = storage.local.get('menu_history')
        if(!histories) {
           histories = []
        }
        this.histories = histories
        this.search = this.$route.params.keywords
    },
    computed: {
        searchMenus() {
            if(!this.search || this.search == '') {
                return this.histories
            }
            else {
                return this.menus.filter(m => (m.toLowerCase().indexOf(this.search.toLowerCase()) > -1))
            }
        },
        menus() {
            let menus = this.$store.state.game.menus
            if(menus) {
                let subs = []
                menus.forEach((m)=>{
                    subs = subs.concat(m.sub)
                })
                return _.uniq(_.map(subs, 'name'))
            }
            return []
        },
    },
    data() {
        return {
            histories: [],
            search: null,
            focus: false
        }
    },
    methods: {
        goToMenu() {
            this.$store.commit('set_menuHistory', this.search);
            this.$router.push({name:'menu', params:{keywords:this.search}})
        },
    }
}
</script>

<style lang="less" scope>
    .page_searchbar {
        position:relative;
        z-index:1029;
        .search_bar {
            background:#fff;
            .ant-btn {
                height:40px;
                border-radius: 0 4px 4px 0;
            }
        }
        .search_bar_box {
            width:100%;
            height: 64px;
            padding: 12px 0;
            background: #fff;
            display: flex;
            .search_box {
                height: 40px;
                flex:1;
                .search {
                    height: 40px;
                    input {
                        background: #f5f5f5;
                        border:none;
                        border-radius: 4px 0 0 4px;
                        &:focus {
                            box-shadow: none;
                        }
                    }
                }
            }
            .search_divider {
                padding:0 30px;
                background:#f5f5f5;
                .search_divider_line {
                    height:1px;
                    background: #ccc;
                }
            }
            .search_history {
                width:100%;
                max-height: 310px;
                overflow: hidden;
                overflow-y:auto;
                box-shadow: 3px 6px 6px rgba(0,0,0,0.1);
                background:#f5f5f5;
                padding:0 30px;
                ul {
                    margin: 0;
                    padding: 10px 0;
                    li {
                        cursor: pointer;
                        line-height: 30px;
                        color:#000;
                        .anticon {
                            margin:0 10px 0 0;
                        }
                        &.no_related {
                            cursor:inherit;
                            color:#aaa;
                        }
                    }
                }
            }
        }
    }
</style>